// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DonationRouteImport } from './routes/donation'
import { Route as CustomerRouteImport } from './routes/customer'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CartRouteImport } from './routes/cart'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsProductIdRouteImport } from './routes/products/$productId'
import { Route as PreviewProductsRouteImport } from './routes/preview/products'
import { Route as InternalRevenueRouteImport } from './routes/internal/revenue'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as CheckoutCancelRouteImport } from './routes/checkout/cancel'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as DonationThanksRouteImport } from './routes/donation/thanks'
import { Route as CustomerIndexRouteImport } from './routes/customer/index'
import { Route as CustomerRewardsRouteImport } from './routes/customer/rewards'
import { Route as CustomerOrdersRouteImport } from './routes/customer/orders'
import { Route as CustomerLoginRouteImport } from './routes/customer/login'
import { Route as CustomerBalanceRouteImport } from './routes/customer/balance'
import { Route as CheckoutCryptoPaymentIdRouteImport } from './routes/checkout/crypto.$paymentId'
import { Route as CustomerOrdersOrderIdRouteImport } from './routes/customer/orders/$orderId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DonationRoute = DonationRouteImport.update({
            id: '/donation',path: '/donation',getParentRoute: () => rootRouteImport
          })
const CustomerRoute = CustomerRouteImport.update({
            id: '/customer',path: '/customer',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
            id: '/products/$productId',path: '/products/$productId',getParentRoute: () => rootRouteImport
          })
const PreviewProductsRoute = PreviewProductsRouteImport.update({
            id: '/preview/products',path: '/preview/products',getParentRoute: () => rootRouteImport
          })
const InternalRevenueRoute = InternalRevenueRouteImport.update({
            id: '/internal/revenue',path: '/internal/revenue',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
            id: '/checkout/cancel',path: '/checkout/cancel',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/admin/dashboard',path: '/admin/dashboard',getParentRoute: () => rootRouteImport
          })
const DonationThanksRoute = DonationThanksRouteImport.update({
            id: '/thanks',path: '/thanks',getParentRoute: () => DonationRoute
          })
const CustomerIndexRoute = CustomerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CustomerRoute
          })
const CustomerRewardsRoute = CustomerRewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => CustomerRoute
          })
const CustomerOrdersRoute = CustomerOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => CustomerRoute
          })
const CustomerLoginRoute = CustomerLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => CustomerRoute
          })
const CustomerBalanceRoute = CustomerBalanceRouteImport.update({
            id: '/balance',path: '/balance',getParentRoute: () => CustomerRoute
          })
const CheckoutCryptoPaymentIdRoute = CheckoutCryptoPaymentIdRouteImport.update({
            id: '/checkout/crypto/$paymentId',path: '/checkout/crypto/$paymentId',getParentRoute: () => rootRouteImport
          })
const CustomerOrdersOrderIdRoute = CustomerOrdersOrderIdRouteImport.update({
            id: '/$orderId',path: '/$orderId',getParentRoute: () => CustomerOrdersRoute
          })





const CustomerOrdersRouteChildren = {
  CustomerOrdersOrderIdRoute: CustomerOrdersOrderIdRoute
}

const CustomerOrdersRouteWithChildren = CustomerOrdersRoute._addFileChildren(CustomerOrdersRouteChildren)



const CustomerRouteChildren = {
  CustomerBalanceRoute: CustomerBalanceRoute,CustomerLoginRoute: CustomerLoginRoute,CustomerOrdersRoute: CustomerOrdersRouteWithChildren,CustomerRewardsRoute: CustomerRewardsRoute,CustomerIndexRoute: CustomerIndexRoute
}

const CustomerRouteWithChildren = CustomerRoute._addFileChildren(CustomerRouteChildren)




const DonationRouteChildren = {
  DonationThanksRoute: DonationThanksRoute
}

const DonationRouteWithChildren = DonationRoute._addFileChildren(DonationRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CartRoute: CartRoute,ContactRoute: ContactRoute,CustomerRoute: CustomerRouteWithChildren,DonationRoute: DonationRouteWithChildren,FaqRoute: FaqRoute,RefundRoute: RefundRoute,ShopRoute: ShopRoute,TermsRoute: TermsRoute,AdminDashboardRoute: AdminDashboardRoute,AdminLoginRoute: AdminLoginRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutCancelRoute: CheckoutCancelRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,InternalRevenueRoute: InternalRevenueRoute,PreviewProductsRoute: PreviewProductsRoute,ProductsProductIdRoute: ProductsProductIdRoute,CheckoutCryptoPaymentIdRoute: CheckoutCryptoPaymentIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)